/**
 * The currencies EVI prices, charges and pays out in (item 3, 2026-10-02).
 *
 * Warren: "Canadian home tariffs are priced, displayed, charged and paid
 * out in CAD; US homes in USD." A tariff carries exactly one of these, in
 * the uppercase ISO 4217 form Stripe and Intl both take, and it can never
 * change after the tariff is created (Tariff.currency is immutable). That
 * immutability is what pins a session's currency at start: a session pins
 * its tariff_id, and the tariff's currency cannot move under it.
 *
 * Shared so the API, the admin and the driver app agree on the list and
 * the type. Pure: no I/O.
 */
export const SUPPORTED_CURRENCIES = ['USD', 'CAD'];
/** True for 'USD' or 'CAD' exactly (uppercase, as stored). */
export function isSupportedCurrency(value) {
    return typeof value === 'string' && SUPPORTED_CURRENCIES.includes(value);
}
/**
 * A stored or wire currency in its comparison form: trimmed, uppercase,
 * and only when it is one EVI supports. Null for anything else, so a
 * caller decides what an unknown value means instead of this guessing.
 */
export function normalizeCurrency(value) {
    if (typeof value !== 'string')
        return null;
    const upper = value.trim().toUpperCase();
    return isSupportedCurrency(upper) ? upper : null;
}
/** The currency of a home or site in a country EVI serves. */
export function currencyForCountry(country) {
    return country === 'CA' ? 'CAD' : 'USD';
}
//# sourceMappingURL=currency.js.map